import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vat'
})
export class VatPipe implements PipeTransform {

  transform(sum: number, vat: number): number {
    if (sum && vat) {
      return sum * (vat / 100);
    }
    return 0;
  }

}
